<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M18.41 7.41L17 6l-6 6 6 6 1.41-1.41L13.83 12l4.58-4.59M12.41 7.41L11 6l-6 6 6 6 1.41-1.41L7.83 12l4.58-4.59Z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronDoubleLeftIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
